import { Box, Typography, SxProps, Link } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Linkify from 'react-linkify';
import { useTheme } from '@mui/material/styles';

export const ExpandableParagraph = ({ text, sx, defaultLines = 10, sxCollapsed }: { text: string, sx?: SxProps, defaultLines?: number, sxCollapsed?: SxProps }) => {
	const theme = useTheme();
	const [isExpanded, setIsExpanded] = useState(false);
	const [isOverflowing, setIsOverflowing] = useState(false);
	const paragraphRef = useRef<HTMLParagraphElement>(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (paragraphRef.current) {
			setIsOverflowing(paragraphRef.current.scrollHeight > paragraphRef.current.clientHeight);
		}
	}, [text]);

	return <Box mb={3} sx={{...((!isExpanded && sxCollapsed) ? sxCollapsed : {}), ...sx} as SxProps}>
		<Typography ref={paragraphRef} sx={{
			whiteSpace:'pre-line', '& > p': {m: 0},
			overflow: 'hidden',
			display: '-webkit-box',
			WebkitLineClamp: isExpanded ? 'unset' : defaultLines,
			WebkitBoxOrient: 'vertical',
			textOverflow: 'ellipsis',
		}}>
			<Linkify
				componentDecorator={(href, text, key) => (
					<a
						key={key}
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: theme.palette.secondary.main, textDecoration: 'underline' }}
					>
						{text}
					</a>
				)}
			>
				{text}
			</Linkify>
		</Typography>
		{isOverflowing && (
			<Link onClick={() => setIsExpanded(!isExpanded)} sx={{mt:isExpanded ? 1 : 0, textDecoration: 'underline', cursor: 'pointer', display: 'inline-block'}}>
				{isExpanded ? t('common.showLess') : t('common.showMore')}
			</Link>)}
	</Box>;
};
